<template>
    <v-progress-linear indeterminate v-if="loading"/>
    <v-layout wrap fill-height v-else>
        <v-flex md8 lg9 xl9 sm12>
            <v-container class="pb-0">
                <v-card>
                    <v-toolbar dense flat :color="car.deleted_at ? 'red darken-2' : 'blue-grey darken-2'" dark>
                        <v-toolbar-title>
                            Vis bil
                            <span v-if="car.deleted_at">&nbsp; (arkivert)</span>
                        </v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <v-layout wrap align-center>
                            <v-flex shrink class="mr-5">
                                <h4 class="headline">
                                    {{ car.type }}

                                    <short-label v-if="car.category" :short="car.category.short_name"
                                                 :label="car.category.name"/>
                                    <v-chip small outlined color="green" v-if="car.is_leasing" class="ml-2">Leasingbil</v-chip>
                                </h4>
                                <span class="grey--text text--darken-2" v-if="car.reg_number">
                                    Reg.nr. {{ car.reg_number }}
                                </span>
                                <strong class="d-block" v-if="car.contact_name">{{ car.contact_name }}</strong>
                            </v-flex>
                            <v-spacer class="hidden-md-and-down"/>
                            <v-flex shrink v-if="!car.deleted_at">
                                <v-btn text @click="showSMS = !showSMS" color="indigo">
                                    <v-icon left>message</v-icon>
                                    Send SMS
                                </v-btn>
                                <v-btn text color="red" @click="remove">
                                    <v-icon left>archive</v-icon>
                                    Arkiver bil
                                </v-btn>
                                <edit-car-dialog :car-id="car.id" @save="onCarSave"/>
                                <v-btn text color="green" v-if="$route.params.storage || $route.params.base"
                                       @click="newTireStorage">
                                    <v-icon left>add_circle</v-icon>
                                    Ny <span class="hidden-md-and-down">dekklagring</span>
                                </v-btn>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                    <v-card-text v-if="car.note" class="grey lighten-4 pre-line">
                        {{ car.note }}
                    </v-card-text>
                </v-card>
            </v-container>

            <router-view></router-view>

            <SmsDialog v-if="showSMS" :car-id="carId" v-model="showSMS"></SmsDialog>
        </v-flex>
        <v-flex md4 lg3 xl3 sm12 class="blue-grey darken-3 pa-3">
            <customer-card :customer="customer" :car="car" class="mb-2"/>
            <v-container grid-list-md class="pa-0">
                <v-layout row wrap>
                    <v-flex md12 lg6>
                        <v-btn color="blue-grey" block large dark class="mx-0 mb-3" @click="goBack">
                            <v-icon left>arrow_back</v-icon>
                            Tilbake
                        </v-btn>
                    </v-flex>
                    <v-flex md12 lg6>
                        <v-btn color="blue-grey" block large dark class="mx-0 mb-3"
                               :to="{name: 'CustomerShow', params: {id: customer.id}}">
                            <v-icon left>person</v-icon>
                            Kundekort
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-container>

            <tire-storage-history :car-id="carId" ref="history"/>
            <sms-log :car-id="carId" class="mt-3" ref="smslog"/>
            <change-log-list :car-id="carId" class="mt-3" ref="changelog"/>
            <invoice-list :car-id="carId" class="mt-3" ref="invoices"/>
        </v-flex>
    </v-layout>
</template>

<script>
    import CustomerCard from "../helpers/CustomerCard";
    import EditCarDialog from "../helpers/EditCarDialog";
    import TireStorageHistory from "../helpers/TireStorageHistory";
    import ChangeLogList from "../helpers/ChangeLogList";
    import ShortLabel from "../helpers/ShortLabel";
    import SmsLog from "@/components/helpers/SmsLog";
    import SmsDialog from "@/components/helpers/SmsDialog";
    import InvoiceList from "@/components/helpers/InvoiceList";

    export default {
        components: {
            CustomerCard,
            EditCarDialog,
            TireStorageHistory,
            SmsLog,
            ChangeLogList,
            InvoiceList,
            ShortLabel,
            SmsDialog
        },

        data() {
            return {
                loading: false,
                customer: null,
                car: null,
                showSMS: false,
                sms: null
            }
        },

        created() {
            this.loadData();
        },

        methods: {
            loadData() {
                this.loading = true;

                let promises = [
                    this.$http.get(`cars/${this.carId}`).then(response => {
                        this.car = response.data.data;

                        // Load sms for car.
                        this.$http.get(`sms/${this.car.id}`).then(response => {
                            this.sms = response.data.data;
                        })

                        // Load customer.
                        return this.$http.get(`customers/${this.car.customer_id}`).then(response => {
                            this.customer = response.data.data;
                        })
                    })
                ];

                Promise.all(promises).finally(() => {
                    this.loading = false;
                })
            },

            onCarSave(newCar) {
                this.loadData();
            },

            goBack() {
                history.back();
            },

            newTireStorage() {
                let ok = confirm('Vil du fylle ut en ny, tom dekklagring?');
                if (!ok) return;
                this.$router.push({
                    name: 'TireStorageCreate',
                    params: {
                        id: this.carId
                    },
                    query: {
                        'new': true
                    }
                });
            },

            remove() {
                let ok = confirm('Vil du virkelig slette denne bilen? Bilen kan bare slettes dersom den ikke har noen dekk på dekkhotellet for øyeblikket.');
                if (!ok) return;

                this.$http.delete(`cars/${this.carId}`).then(response => {
                    this.$root.addMessage(response.data.message, 'green');
                    this.$router.push({name: 'CustomerShow', params: {id: this.car.customer_id}});
                }).catch(error => {
                    this.$root.addMessage(error.response.data.message, 'red');
                })
            }
        },

        watch: {
            '$route.name'() {
                // We should see CarShow. Either loadData redirects to "empty" page or most recent active storage.
                if (this.$route.name === 'CarShow') {
                    this.loadData();
                }
            },
            carId() {
                this.loadData();
            }
        },

        computed: {
            carId() {
                return parseInt(this.$route.params.id);
            }
        }
    }
</script>
